import { API_BASE } from './api';
import { getToken } from './tokenStorage';

const authHeaders = () => {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

/** Chat Coach in streaming (SSE via fetch): chiama onDelta per ogni pezzo di testo. */
export async function streamCoachChat({ leadId, message, sessionId, lang, onDelta }) {
  const resp = await fetch(`${API_BASE}/coach/leads/${leadId}/chat`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
    body: JSON.stringify({ message, session_id: sessionId || null, lang }),
  });
  if (!resp.ok || !resp.body) throw new Error(`Coach non disponibile (${resp.status})`);
  const reader = resp.body.getReader();
  const decoder = new TextDecoder();
  let buf = '';
  let sid = sessionId;
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += decoder.decode(value, { stream: true });
    const events = buf.split('\n\n');
    buf = events.pop();
    for (const ev of events) {
      const line = ev.trim();
      if (!line.startsWith('data:')) continue;
      const data = JSON.parse(line.slice(5).trim());
      if (data.delta) onDelta(data.delta);
      if (data.error) throw new Error(data.error);
      if (data.done) sid = data.session_id;
    }
  }
  return sid;
}

/** Copia negli appunti con fallback (permessi negati / contesto non sicuro). */
export async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text || '');
    return true;
  } catch {
    const ta = document.createElement('textarea');
    ta.value = text || '';
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    try {
      ta.select();
      return document.execCommand('copy');
    } catch {
      return false;
    } finally {
      document.body.removeChild(ta);
    }
  }
}

/** Upload a pezzi (4 MB) della registrazione → crea l'analisi lato server. */
export async function uploadCoachRecording({ leadId, file, lang, onProgress }) {
  const init = await fetch(`${API_BASE}/coach/uploads/init`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
    body: JSON.stringify({ lead_id: leadId, filename: file.name, size: file.size, lang }),
  });
  const meta = await init.json();
  if (!init.ok) throw new Error(meta?.detail || 'Caricamento non riuscito');
  const { upload_id: upId, chunk_size: size, total_chunks: total } = meta;
  for (let i = 0; i < total; i += 1) {
    const blob = file.slice(i * size, (i + 1) * size);
    let ok = false;
    for (let attempt = 0; attempt < 3 && !ok; attempt += 1) {
      const r = await fetch(`${API_BASE}/coach/uploads/${upId}/chunk?index=${i}`, {
        method: 'PUT', headers: { 'Content-Type': 'application/octet-stream', ...authHeaders() }, body: blob,
      });
      ok = r.ok;
    }
    if (!ok) throw new Error('Connessione interrotta durante il caricamento, riprova');
    onProgress?.(Math.round(((i + 1) / total) * 100));
  }
  const done = await fetch(`${API_BASE}/coach/uploads/${upId}/complete`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
    body: JSON.stringify({ total_chunks: total }),
  });
  const call = await done.json();
  if (!done.ok) throw new Error(call?.detail || 'Caricamento non riuscito');
  return call;
}
